const data = [
  {
    key: 0,
    email: 'aaron@wd.com',
  },
  {
    key: 1,
    email: 'daniela@wd.com',
  },
  {
    key: 2,
    email: 'stilyan@wd.com',
  },
  {
    key: 3,
    email: 'jacob@cweb.dk',
  },
  {
    key: 4,
    email: 'stefan@cweb.dk',
  },
];

export default data;
